<template>
  <div>

    <Row>
      <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                  format="dd/MM/yyyy" class="filterInput" style="width: 260px" @on-change="onChangeDate"></DatePicker>
      <Button v-if="isAdmin" style="float: right; margin:-5px 0 6px 0" @click="exportTruckOrders">Export CSV</Button>
    </Row>

    <Spin fix size="small" v-if="skipTruckOrders"></Spin>

    <hot-table :settings="hotSettings" ref="hotTableComponent" style="margin: 20px 0 0 0">
      <hot-column v-for="(colset, index) in [...columns]" :settings="colset" :key="index">
      </hot-column>
    </hot-table>

  </div>
</template>

<script>
  import {
    calculateTotalWeightOfOrders,
    hotSettingsTruckOrders,
    truckOrderObj
  } from './Settings'
  import {dateOptions} from "../ExcelFormattedOrders/Settings"
  import { HotTable, HotColumn } from '@handsontable/vue'
  import {weightRenderer, truckOrderNumRenderer, truckOrderStatusRenderer, ewayBillRenderer} from "./RendererFunctions"
  import {
    SUBSCRIBE_EXCEL_COMPLETED_TRUCK_ORDERS
  } from "../../graphql/subscription/truckOrders"
  import moment from 'moment'
  import {Constants} from "../../Constants/Constant";
  export default {
    name: "CompletedTruckOrders",
    components: {HotTable, HotColumn},
    props:['globalSearch'],
    apollo: {
      $subscribe: {
        completed_truckOrders: {
          query: SUBSCRIBE_EXCEL_COMPLETED_TRUCK_ORDERS,
          skip(){return this.skipTruckOrders},
          variables () {
            return {
              startDate: this.startDate,
              endDate: this.endDate
            }
          },
          result ({ data }) {
            console.log('Excel Completed Truck Orders Subscribed')
            this.completed_truckOrders = data.completed_truckOrders
            this.prepareSheetData(data.completed_truckOrders)
          },
        },
      },
    },
    data: function () {
      return{
        completed_truckOrders: [],
        skipTruckOrders: true,
        filterDate: [moment().subtract(2, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
        startDate: moment().subtract(2, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        dateOptions: dateOptions,
        columns: [
          //table_key_intermediate
          {
            title: 'Booking<br> Date',
            data: 'bookingDate',
            type: 'date',
            dateFormat: 'DD/MM/YYYY'
          },
          {
            title: 'Truck Order<br> Number',
            data: 'truckOrderNumber',
            renderer: truckOrderNumRenderer
          },
          {
            title:'Status',
            data: 'internalStatusId',
            component: 'ActionPopup',
            renderer: truckOrderStatusRenderer
          },
          {
            title:'Truck<br> Number',
            data: 'truckPlateNum',
          },
          {
            title:'Transporter',
            data: 'transporter'
          },
          {
            title:'Driver',
            data: 'driver',
          },
          {
            title:'Eway Bill No.',
            data: 'truckOrders_ewayBillNo',
            renderer: (...args) => ewayBillRenderer(...args, true)
          },
          {
            title:'No of<br> Orders',
            data: 'numOfOrders',
            type: 'numeric'
          },
          {
            title:'Total/<br>Committed<br>Wt(Kg)',
            data: 'truckOrders_commitedWeight',
            type: 'numeric',
            renderer: (...args) => weightRenderer(...args, true)
          },
          {
            title:'Pickup<br> City',
            data: 'fromCity',
          },
          {
            title:'Drop<br> City',
            data: 'toCity',
          },
          {
            title:'Rate<br> (per ton)',
            data: 'truckOrders_price',
            type: 'numeric',
          },
          {
            title:'LR<br> Comm',
            data: 'lrCommision',
            type: 'numeric'
          },
          {
            title:'Approx<br> Payment',
            data: 'payment',
            type: 'numeric',
            numericFormat: { pattern: '0,00' }
          },
        ],
        hotSettings: hotSettingsTruckOrders([110, 170, 145, 100, 145, 140, 130, 100, 120, 100, 90, 100, 90, 110, 100], this),
        confirmDialog: false,
        confirmObj: {},
        runCommentMethod: false,
        updateRecord_loader: false,
        evaluatedWeight: 0,
        addTruckOrderDrawer: false
      }
    },
    computed: {
      isAdmin: function(){
        return this.$store.state.userObj.role[0].id === Constants.adminRoleId
      }
    },
    methods:{
      onChangeDate(evt){
        this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      },
      prepareSheetData(data, screen){
        let mainArr = [], totalOrders = 0, totalWeight = 0;
        data.forEach(curnt => {
          curnt.obj = {
            bookingDate: moment(curnt.bookingDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            truckOrderNumber: curnt.truckOrderNumber,
            internalStatusId: curnt.InternalStatus?curnt.InternalStatus.id:'',
            truckPlateNum: curnt.truck.platNo,
            transporter: curnt.Transporter.name,
            driver: curnt.driverDetail.name,
            truckOrders_ewayBillNo: curnt.ewayBillNo,
            numOfOrders: curnt.orderDetailsArr.length,
            truckOrders_commitedWeight: parseInt(curnt.commitedWeight),
            fromCity: curnt.fromCity,
            toCity: curnt.toCity,
            truckOrders_price: parseInt(curnt.price),
            lrCommision: curnt.lrCommision,
            payment: (curnt.commitedWeight*curnt.price/1000)-curnt.lrCommision,
            truckOrders_status: curnt.status,
            orderDetailsArr: curnt.orderDetailsArr,
            truckOrderId: curnt.id,
            internalstatus: curnt.InternalStatus?curnt.InternalStatus.name:''
          }
          mainArr.push(curnt.obj)
          totalOrders = totalOrders + curnt.orderDetailsArr.length;
          totalWeight = totalWeight + Number(calculateTotalWeightOfOrders(curnt.orderDetailsArr));
        })
        if(mainArr.length) mainArr.push({...truckOrderObj, numOfOrders: totalOrders, truckOrders_commitedWeight: totalWeight+'NA'}); //appending NA to skip renderer

        this.hotSettings.data = mainArr
      },
      exportTruckOrders(){
        let hotInstance = this.$refs.hotTableComponent.hotInstance;
        let exportPlugin = hotInstance.getPlugin('exportFile');
        exportPlugin.downloadFile('csv', {
          columnHeaders: true,
          filename: 'Completed_TruckOrders_'+ moment().format('DD_MMM_YYYY_HH_mm'),
        });
      }
    },
    mounted(){
      setTimeout(() => {
        this.skipTruckOrders = false
      }, 500)

    }
  }
</script>

<style scoped>
  /deep/  .ivu-spin-fix {
    top: 43px;
    left: 16px;
    z-index: 8;
    width: 86vw;
    height: 40vh;
  }
  /deep/ .handsontable > .ht_master{
    font-size: 14px;
  }
  /deep/ .handsontable > .ht_master > .wtHolder{
    /*width: 100% !important;*/
    width: unset !important;
    height: unset !important;
  }
  /deep/ .handsontable span.colHeader {
    font-size: 13px;
  }
  /deep/.handsontable td{
    vertical-align: middle !important;
    padding: 0 1px 0 1px !important;
    white-space: unset !important;
    font-size: 13px;
  }

  /deep/.handsontable th{
    background-color: #d9d9d9;
    color: #222;
    text-align: center;
    font-weight: 600;
    vertical-align: middle !important;
    white-space: nowrap !important;
    padding: 0 0px 0 0px !important;
  }

  /deep/ .handsontable .spotlight{
    font-size: 15px;
    text-align: center;
    color: teal;
    font-weight: 600;
  }

  .filterInput{
    width: 80%;
  }
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  /deep/ .ivu-picker-panel-sidebar  {
    width:125px !important;
    margin-left:-116px !important;
  }
</style>
<style>
  .truck-order-num-txt:hover {
    text-decoration: underline;
  }
  .filterInput{
    width: 80%;
  }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
